import React, { Component } from 'react';
import { Box } from 'bloomer/lib/elements/Box';
import { Columns } from 'bloomer/lib/grid/Columns';
import { Column } from 'bloomer/lib/grid/Column';
import { Content } from 'bloomer/lib/elements/Content';
import AnimalSignOutForm from './AnimalSignOutForm';
import AnimalSignInForm from './AnimalSignInForm';
import { Button } from 'bloomer';
import CommentModal from './CommentModal';
import Animal from '../Entities/Animal';
import Bold from '../elements/Bold';
import styled from 'styled-components';
import { trackers } from '../util/analytics';

interface Proptypes {
  animal: Animal;
  refresh: () => void;
}

interface Statetypes {
  isModalOpen: boolean;
}

const BioSecurityIcon = styled.img`
  max-width: 20px;
  margin-left: 5px;
`;

const VCenterParagraph = styled.p`
  display: flex;
  align-items: center;
  strong {
    margin-right: 5px;
  }
`;

class AnimalInfoCard extends Component<Proptypes, Statetypes> {
  state = {
    isModalOpen: false,
  };

  toggleModal = () => {
    const { animal } = this.props;
    this.setState({ isModalOpen: !this.state.isModalOpen });
    if (animal.isDog()) {
      trackers.dogList.click().OPEN_ANIMAL_COMMENTS();
    }
    if (animal.isCat()) {
      trackers.catList.click().OPEN_ANIMAL_COMMENTS();
    }
  };

  render() {
    const { animal } = this.props;
    const { specialNeeds } = animal;
    const breedText = animal.animalType === 'dog' ? 'Breed' : 'Fur Colour / Pattern';
    return (
      <>
        <Box id={`info-card-${animal.aNumber}`}>
          <Content>
            <Columns>
              <Column>
                <p>
                  <strong>Animal Name:</strong> {animal.name}
                </p>
                <p>
                  <strong>Color Code:</strong> {animal.colorCode}
                </p>
                <VCenterParagraph>
                  <strong>Location:</strong> {animal.getLocationName()}
                  <BioSecurityIcon src={animal.locationEntity.getIcon()} alt={animal.locationEntity.getHelpText()} />
                </VCenterParagraph>
                <p>
                  <strong>{breedText}:</strong> {animal.breed}
                </p>
                <p>
                  <strong>Special Needs:</strong>
                  {specialNeeds.length === 0 ? ' None' : ''}
                </p>
                <ul>
                  {specialNeeds.map(({ _id, name }) => (
                    <li key={_id}>
                      <p>{name}</p>
                    </li>
                  ))}
                </ul>
              </Column>
              <Column>
                <p>
                  <strong>Note: </strong>
                  {animal.note}
                </p>
                <p>
                  <Bold>Training Plan:</Bold> {animal.trainingPlan.toUpperCase()}
                </p>
              </Column>
              <Column>
                {animal.signOutData === null ? (
                  <AnimalSignOutForm animal={animal} />
                ) : (
                  <AnimalSignInForm animal={animal} refresh={this.props.refresh} />
                )}
              </Column>
            </Columns>
          </Content>
          <Button isColor="primary" onClick={this.toggleModal}>
            Comments
          </Button>
        </Box>
        <CommentModal isOpen={this.state.isModalOpen} animal={animal} closeModal={this.toggleModal} />
      </>
    );
  }
}

export default AnimalInfoCard;
